import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { logout as taurianLogout } from '../apis/auth';
import { getMe } from '../apis/ride-24';
import ApplyOrganiserPage from './ApplyOrganiserPage';
import CreateEvent from './CreateEvent';
import Dashboard from './Dashboard';
import EditEvent from './EditEvent';
import EventDetails from './EventDetails';
import Header from './Header';
import LoadingScreen from './LoadingScreen';
import MyRidesPage from './MyRidesPage';
import { Toaster } from './ui/sonner';
import './ride-24.css';

const Ride24App = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = async () => {
    const { data } = await getMe();
    setUser(data.user);
    return data.user;
  };

  useEffect(() => {
    document.body.classList.add('ride-24-root', 'dark');
    return () => {
      document.body.classList.remove('ride-24-root', 'dark');
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    const boot = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        sessionStorage.setItem('postLoginRedirect', '/ride-24');
        if (!cancelled) setLoading(false);
        navigate('/Login', { replace: true });
        return;
      }

      try {
        const { data } = await getMe();
        if (!cancelled) setUser(data.user);
      } catch (error) {
        console.error('Ride24 auth failed', error);
        if (!cancelled) {
          sessionStorage.setItem('postLoginRedirect', '/ride-24');
          navigate('/Login', { replace: true });
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    boot();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await taurianLogout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      setUser(null);
      toast.success('Logged out successfully');
      navigate('/Login', { replace: true });
    }
  };

  if (loading) {
    return (
      <div className="ride-24-root dark">
        <LoadingScreen message="Loading..." />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/Login" replace />;
  }

  return (
    <div className="ride-24-root dark">
      <Header user={user} onLogout={handleLogout} onUserRefresh={refreshUser} />
      <Routes>
        <Route index element={<Dashboard user={user} />} />
        <Route path="my-rides" element={<MyRidesPage user={user} />} />
        <Route
          path="create-event"
          element={<CreateEvent user={user} onUserRefresh={refreshUser} />}
        />
        <Route
          path="apply-organiser"
          element={<ApplyOrganiserPage user={user} onUserRefresh={refreshUser} />}
        />
        <Route path="events/:eventId" element={<EventDetails user={user} onUserRefresh={refreshUser} />} />
        <Route path="events/:eventId/edit" element={<EditEvent user={user} />} />
        <Route path="*" element={<Navigate to="/ride-24" replace />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default Ride24App;
